// extracted by mini-css-extract-plugin
export default {"eventvideo":"EventHero_eventvideo__dIgz9"};